<main class="min-h-0 d-flex flex-column flex-grow-1 overflow-hidden">
  <div class="d-grid gap-2 d-md-flex justify-content-between gw-header sticky-sm-top align-items-center">
    <a href="{{ homeUrl }}">
      <img class="logo align-self-center ps-3" src="calendar-logo.png" height="70px" alt="Groundworks Call Center" />
    </a>
    <div class="affiliate col-3 align-self-center text-center">
      <span class="fw-normal" id="selected-branch">{{ selectedBranch }}</span>
    </div>
    <div class="user-details-wrapper col-2">
      <div class="user-details">
        <div class="user-name">
          <span *ngIf="!configService.production" class="badge badge-pill bg-danger" id="environment-badge">{{
            configService.env
            }}</span>
          <span class="dropdown">
            <button class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false">
              {{ whoami }}
            </button>
            <div class="dropdown-menu" style="z-index: 1100">
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </div>
          </span>
        </div>
        <div class="user-image"></div>
      </div>
    </div>
  </div>
  <router-outlet />
</main>
